import { MenuItem } from '../interfaces/menu-item';

export const getMenuItemUrl = (menuItem: MenuItem): string => {
  if (menuItem.externalUrl) {
    return menuItem.externalUrl;
  }

  if (menuItem.targetPage) {
    return menuItem.targetPage.url;
  }

  return '';
};
